import Reveal from "@/components/Reveal";

export default function SectionHeading({ eyebrow, title, sub, dark = false, center = false, id }) {
  return (
    <Reveal className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`} y={20}>
      {eyebrow && (
        <p className={`eyebrow mb-4 ${dark ? "text-gold" : "text-earth"}`} data-testid={id ? `${id}-eyebrow` : undefined}>
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className={`text-balance font-display text-3xl font-semibold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-ivory" : "text-forest"}`}
      >
        {title}
      </h2>
      {sub && <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-ivory/75" : "text-mutedink"}`}>{sub}</p>}
    </Reveal>
  );
}
